import { createContext, useContext, useEffect, useState } from "react";
import { useLocation, matchPath } from "react-router-dom";

export const routeTitles = {
    '/': 'Homepage',
    '/signin': 'Sign In',
    '/signup': 'Sign Up',
    '/house/id/:id/reports': 'Live Monitoring',
    '/house/id/:id/devices': 'Devices',
    '/add/house': 'Add House',
    '/get-started': 'Get Started',
    'house/:id/edit': 'Edit House',
};

const PageTitleContext = createContext({ title: '' });

function getTitleForPath(path) {
    for (const pattern in routeTitles) {
        if (matchPath({ path: pattern, end: true }, path)) {
            return routeTitles[pattern];
        }
    }
    return "Untitled";
}

export function PageTitleProvider({ children }) {
    const location = useLocation();
    const [title, setTitle] = useState("");

    useEffect(() => {
        const path = location.pathname;
        const baseTitle = getTitleForPath(path);
        const fullTitle = `${baseTitle} | Energy Home System`;
        setTitle(fullTitle);
        document.title = fullTitle;
    }, [location.pathname]);

    return (
        <PageTitleContext.Provider value={{ title }}>
            {children}
        </PageTitleContext.Provider>
    );
}

export const usePageTitle = () => useContext(PageTitleContext); 